"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectMarketGroupsByEventV4 = exports.selectMarketOutcomes = exports.makeMarketOutcomesSelector = exports.selectOutcomesCategoriesFiltered = exports.selectOutcomesCategories = exports.selectOutcomes = exports.EMPTY_OUTCOMES = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const selectors_1 = require("../../CommonDataProvider/selectors");
const utils_1 = require("../utils");
const regExp_1 = require("../../../utils/regExp");
const marketSelectors_1 = require("./marketSelectors");
// TODO: Retrun empty oucomes ?
exports.EMPTY_OUTCOMES = {
    categories: [],
    markets: {},
};
const selectOutcomes = (state, eventId) => {
    var _a;
    return (_a = state.eventsProvider.outcomes[eventId]) !== null && _a !== void 0 ? _a : exports.EMPTY_OUTCOMES;
};
exports.selectOutcomes = selectOutcomes;
const selectOutcomesCategories = (state, eventId) => {
    return (0, exports.selectOutcomes)(state, eventId).categories;
};
exports.selectOutcomesCategories = selectOutcomesCategories;
const selectCategoriesByMarketGroup = marketSelectors_1.selectGroupCategoriesMapFilterForMarketCategoriesInfosByEvent;
exports.selectOutcomesCategoriesFiltered = (0, toolkit_1.createSelector)([
    exports.selectOutcomes,
    selectCategoriesByMarketGroup,
    (_s, __, ___, searchFilter) => searchFilter,
    (_s, __, ___, ____, statusFilter) => statusFilter,
    selectors_1.selectVirtualMarketsInfo,
    selectors_1.selectVirtualCategoriesInfo,
], (outcomes, selectedMarketGroupCategories, searchFilter, tradingStatusFilter, allMarkets, allCategories) => {
    const searchRegExp = searchFilter ? (0, regExp_1.regExpSearchString)(searchFilter) : null;
    const searchRegExpReplace = (0, utils_1.searchRegExpReplaceFunc)(searchRegExp);
    const result = [];
    for (const oCategory of outcomes.categories) {
        const { name, id } = allCategories[oCategory.vCategoryId];
        let updatedName = '';
        let filteredMarkets = oCategory.vMarketIds.map((x) => allMarkets[x]);
        if (selectedMarketGroupCategories) {
            const categoryInMarketGroup = selectedMarketGroupCategories
                ? selectedMarketGroupCategories[id]
                : null;
            if (categoryInMarketGroup) {
                filteredMarkets = filteredMarkets.filter(({ id }) => categoryInMarketGroup.has(id));
            }
            else {
                continue;
            }
        }
        if (tradingStatusFilter) {
            filteredMarkets = filteredMarkets.filter(({ id }) => outcomes.markets[id].tradingStatus === tradingStatusFilter);
        }
        if (searchRegExp) {
            if (!(0, utils_1.doesStringMatchSearchRegExp)(name, searchRegExp)) {
                filteredMarkets = filteredMarkets
                    .filter(({ outcomesGroup }) => (0, utils_1.doesStringMatchSearchRegExp)(outcomesGroup.name || '', searchRegExp))
                    .map(({ outcomesGroup, ...rest }) => ({
                    ...rest,
                    outcomesGroup: {
                        ...outcomesGroup,
                        name: searchRegExpReplace(outcomesGroup.name || ''),
                    },
                }));
            }
            else {
                updatedName = searchRegExpReplace(name);
            }
        }
        if (filteredMarkets.length > 0) {
            result.push({
                vCategoryId: id,
                vCategoryName: updatedName || name,
                vMarkets: filteredMarkets,
            });
        }
    }
    return result;
});
const makeMarketOutcomesSelector = () => {
    const selector = (0, toolkit_1.createSelector)([
        exports.selectMarketOutcomes,
        (_, eventId, vMarketId, tradingStatus) => tradingStatus,
    ], (outcomes, tradingStatus) => {
        if (tradingStatus) {
            return outcomes.filter((outcome) => outcome.tradingStatus === tradingStatus);
        }
        else {
            return outcomes;
        }
    });
    return selector;
};
exports.makeMarketOutcomesSelector = makeMarketOutcomesSelector;
const selectOutcomesMarket = (state, eventId, marketId) => {
    return state.eventsProvider.outcomes[eventId].markets[marketId];
};
exports.selectMarketOutcomes = (0, toolkit_1.createSelector)([selectOutcomesMarket], (marketOutcomes) => {
    const order = marketOutcomes.outcomesOrder;
    return order.map((id) => marketOutcomes.outcomesByKey[id]);
});
exports.selectMarketGroupsByEventV4 = (0, toolkit_1.createSelector)([exports.selectOutcomesCategories, selectors_1.selectMarketGroups], (outcomeCategories, marketGroups) => {
    // For fast lookup
    const categoryMarketIds = outcomeCategories.reduce((acc, cur) => {
        acc[cur.vCategoryId] = new Set(cur.vMarketIds);
        return acc;
    }, {});
    // Filter the marketGroups according to event's marketCategoriesInfos
    return marketGroups.filter((marketGroup) => marketGroup.categories.some((category) => category.categoryMarketIds.some((categoryMarketId) => { var _a; return (_a = categoryMarketIds[category.marketCategoryId]) === null || _a === void 0 ? void 0 : _a.has(categoryMarketId); })));
});
//# sourceMappingURL=outcomesSelectors.js.map